import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { getLocale } from 'lib/utils/getLocale'

import Link from 'components/Link'

import 'styles/status-message.pcss'
import ErrorMessageContent from './ErrorMessageContent'

const DuplicateVehicleRestrictionMessage = ({ appError }) => {
    const { i18n } = useTranslation(['errors'])

    const vehicleId = appError.message.split('|')[1]

    return (
        <ErrorMessageContent
            content={(
                <p>
                    <Trans i18nKey="errors:errorMessage.duplicateRegNumber.message">
                        You already have vehicle with this reg number. <Link to={`${getLocale(i18n.language)}/ajoneuvo/${vehicleId}`} trackName="vehicle">Go to vehicle</Link>
                    </Trans>
                </p>
            )}
        />
    )
}

export default withRouter(DuplicateVehicleRestrictionMessage)
